module.exports = __webpack_public_path__ + "img/PayStackIcon.f7c9e04c.svg";